<div id="dvNCESLogoCoverUpdate" class="row">
	<div class="col-md-5 col-12" style="background-color:#fff; padding:10px; height:400px">
		<div class="jmPageTitle">
			Update School {{type.toUpperCase()}}
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div style="padding:20px 0px; text-align:center;">
			<label [hidden]="openningFile" for="fileInput" class="btn btn-info" style="width:200px;">Upload a {{type}} image</label>
			<span [hidden]="!openningFile" class="jmWidgetLoadingIcon20"></span>
			<input type="file" style="display:none;" id="fileInput" (change)="openFile($event)" />
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-2"></div>
			<div class="col-4" style="text-align:center;"><button class="btn btn-outline-info" style="width:100px;" (click)="cancel()">Cancel</button></div>
			<div class="col-4" style="text-align:center;">
				<span [hidden]="!savingFile" class="jmWidgetLoadingIcon20"></span>
				<button [hidden]="!imageCropped || savingFile" class="btn btn-info" style="width:100px;" (click)="save()">Save</button>
			</div>
			<div class="col-2"></div>
		</div>
	</div>
	<div class="col-md-7 col-12" style="background-color: var(--bs-secondary); height: 400px;">
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row">
			<div class="col-md-12">&nbsp;</div>
		</div>
		<div class="row" *ngIf="type==='logo' && imageCropped">
			<div class="col-12">
				<div class="row">
					<div class="col-sm-7 col-7">&nbsp;</div>
					<div class="col-sm-1 col-1" style="text-align: right;" (click)="removeImage()" role="button"><i class="fas fa-times"></i></div>
					<div class="col-sm-1 col-1">&nbsp;</div>
				</div>
				<div class="row">
					<div class="col-md-12 col-sm-12 col-7 offset-4">
						<div style="margin-left: -1.5em;">
							<div style="overflow: hidden;width: 230px;height: 230px;text-align: center;"><img style="width: 100%;border-radius: 50%;" [src]="myCroppedImage" /></div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<div class="row" *ngIf="type!=='logo' && imageCropped">
			<div class="col-12">
				<div class="row">
					<div class="col-sm-10 col-10">&nbsp;</div>
					<div class="col-sm-1 col-1" style="text-align: right;" (click)="removeImage()" role="button"><i class="fas fa-times"></i></div>
					<div class="col-sm-1 col-1">&nbsp;</div>
				</div>
				<div class="row">
					<div class="col-sm-1 col-1">&nbsp;</div>
					<div class="col-sm-10 col-10">
						<img style="width:100%; height:auto;" [src]="myDisplayCroppedImage" />
					</div>
					<div class="col-sm-1 col-1">&nbsp;</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">&nbsp;</div>
		</div>
	</div>
</div>
